import e from"react";import r from"xss";import{Container as t}from"./styles.js";const o=({value:o=""})=>e.createElement(t,{dangerouslySetInnerHTML:{__html:r(o)}});export{o as Description};
//# sourceMappingURL=Description.js.map
